import React, { useEffect, useState } from "react";
import { Container, Resume, Services, ViewInput } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import {
  MdAdd,
  MdDelete,
  MdDeleteForever,
  MdInfoOutline,
  MdRemove,
} from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { useCart } from "../../../hooks/CartContext";
import {
  AutoComplete,
  Button,
  Input,
  Modal,
  Select,
  Spin,
  Switch,
  Tooltip,
} from "antd";
import { HeaderTitle } from "../../../GlobalStyles";
import { getValue } from "../../../services/functions";
import CountUp from "react-countup";

export default function Solicitacao() {
  const { user } = useAuth();
  const { cart, updateCart, clearCart } = useCart();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isLoadingButton, setIsLoadingButton] = useState(false);
  const [loadingCode, setLoadingCode] = useState(false);
  const [observation, setObservation] = useState(cart.observation);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isUrgent, setIsUrgent] = useState(cart.isUrgent);
  const [reminder, setReminder] = useState(cart.reminder || true);
  const [type, setType] = useState(cart.type || "elaboracao");
  const [name, setName] = useState("");
  const [nameOS, setNameOS] = useState(cart.nameOS);
  const [description, setDescription] = useState("");
  const [sector, setSector] = useState(cart.sector);
  const [discount, setDiscount] = useState(cart.discount);
  const [code, setCode] = useState(cart.code);
  const [value, setValue] = useState(0);
  const [balance, setBalance] = useState(0);
  const [collaborators, setCollaborators] = useState(cart.collaborators);
  const [order, setOrder] = useState(null);
  const [company, setCompany] = useState(cart.company);
  const [companyName, setCompanyName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [companiesC, setCompaniesC] = useState([]);
  const [services, setServices] = useState([]);
  const [servicesOrder, setServicesOrder] = useState(cart.servicesOrder);

  useEffect(() => {
    loadingOSs();
    if (!cart.sector) {
      if (user.resale) {
        setSector("Revenda de treinamentos online");
        updateCart({ sector: "Revenda de treinamentos online" });
      }
      if (user.signature) {
        setSector("Assinatura Documentos SST");
        updateCart({ sector: "Assinatura Documentos SST" });
      }
    }
  }, []);

  async function loadingOSs() {
    await api
      .get(`/services-client`)
      .then((response) => {
        response.data.services.map((item) => {
          item.amount = 0;
        });
        setBalance(response.data.balance);
        setServices(response.data.services);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    await api
      .get(`/companies-confirm`)
      .then((response) => {
        let companies = response.data;

        companies.map((item) => {
          item.value = item.razao_social;
          item.label = item.razao_social;
        });

        setCompanies(companies);
        setCompaniesC(companies);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function getCoupon() {
    setLoadingCode(true);
    await api
      .post(`/get/coupon`, {
        value:
          servicesOrder.reduce((total, item) => {
            const subtotal = item.value * item.amount;
            return total + subtotal;
          }, 0) + (isUrgent ? 147 : 0),
        code: code,
      })
      .then((response) => {
        setDiscount(response.data);
        updateCart({ discount: response.data });
      })
      .catch(({ response }) => {
        setDiscount("");
        updateCart({ discount: null });
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoadingCode(false);
  }

  // Update local state when cart is cleared or changed externally
  useEffect(() => {
    setObservation(cart.observation);
    setIsUrgent(cart.isUrgent);
    setReminder(cart.reminder);
    setNameOS(cart.nameOS);
    setSector(cart.sector);
    setDiscount(cart.discount);
    setCode(cart.code);
    setCollaborators(cart.collaborators);
    setCompany(cart.company);
    setServicesOrder(cart.servicesOrder);
    setType(cart.type || "elaboracao");
  }, [cart]);

  const isFormRequired = servicesOrder.some((item) => item.required_company);
  const isFormMissing = isFormRequired && !company?.id;

  console.log(user);
  return (
    <Container>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          <HeaderTitle style={{ marginBottom: 10 }}>
            <h1>Solicitar OS</h1>
            <div>
              <Button
                type="primary"
                danger
                style={{
                  borderRadius: 50,
                  marginRight: 10,
                }}
                onClick={() => {
                  clearCart();
                  toast.success("Carrinho zerado com sucesso!");
                }}
              >
                <MdDeleteForever size="20" color="#fff" />
                <span>Zerar Carrinho</span>
              </Button>
              <Button
                type="primary"
                style={{
                  borderRadius: 50,
                }}
                onClick={() => {
                  navigate("/cliente/adicionar-saldo");
                }}
              >
                <MdAdd size="20" color="#fff" />
                <span>Adicionar Saldo</span>
              </Button>
            </div>
          </HeaderTitle>

          <p>Saldo disponível para solicitar OS:</p>
          <h3>
            <CountUp
              separator="."
              duration={1.5}
              end={balance}
              prefix="R$ "
              separator="."
              decimal=","
              decimals={2}
            />
          </h3>
          <div className="row">
            <ViewInput>
              <p>Nome da OS</p>
              <Input
                type="text"
                placeholder="razão social da empresa"
                value={nameOS}
                onChange={(text) => {
                  setNameOS(text.target.value);
                  updateCart({ nameOS: text.target.value });
                }}
              />
            </ViewInput>
            <ViewInput style={{ marginRight: 0 }}>
              <p>Quantidade de Funcionarios</p>
              <Input
                type="number"
                placeholder="quantidade de funcionarios da empresa"
                value={collaborators}
                onChange={(text) => {
                  const val = parseInt(text.target.value) || 0;
                  setCollaborators(val);
                  setServicesOrder([]);
                  updateCart({ collaborators: val, servicesOrder: [] });
                }}
              />
            </ViewInput>
            <ViewInput>
              <p>Selecione o Setor</p>
              <Select
                style={{ width: "100%", textAlign: "left" }}
                placeholder="seleciona uma opção"
                value={sector || null}
                disabled={!collaborators}
                onChange={(value) => {
                  if (
                    user.category == "assinatura" &&
                    value != "Assinatura Documentos SST"
                  ) {
                    toast.warn("Seu acesso é apenas para assinatura");
                  } else {
                    let servicesC = services;
                    servicesC.map((item) => {
                      item.amount = 0;
                    });

                    setServices(servicesC);
                    setServicesOrder([]);
                    setSector(value);
                    updateCart({ sector: value, servicesOrder: [] });
                  }
                }}
              >
                {user.category != "assinatura" && (
                  <Select.Option value="Serviços de segurança do Trabalho">
                    Serviços de segurança do Trabalho
                  </Select.Option>
                )}

                {user.category != "assinatura" && (
                  <Select.Option value="Revenda de treinamentos online">
                    Revenda de treinamentos online
                  </Select.Option>
                )}

                {user.category != "assinatura" && (
                  <Select.Option value="Serviços Medicina ocupacional">
                    Serviços Medicina ocupacional
                  </Select.Option>
                )}

                {user.category != "assinatura" && (
                  <Select.Option value="Credenciamento SST">
                    Credenciamento SST
                  </Select.Option>
                )}

                <Select.Option value="Assinatura Documentos SST">
                  Assinatura Documentos SST
                </Select.Option>
              </Select>
            </ViewInput>
            <ViewInput
              style={{ marginRight: 0 }}
              className={isFormMissing ? "required-company-missing" : ""}
            >
              <p
                style={{
                  color: isFormMissing ? "#d48806" : undefined,
                  fontWeight: isFormMissing ? "600" : "normal",
                }}
              >
                Vincular Formulário da Empresa {isFormMissing && " (Obrigatório)"}
              </p>
              <AutoComplete
                status={isFormMissing ? "warning" : undefined}
                style={{
                  width: "100%",
                  fontSize: 14,
                  textAlign: "left",
                }}
                options={companies}
                value={company?.razao_social || companyName}
                notFoundContent={<>Nenhuma empresa encontrado</>}
                onSelect={(text, client) => {
                  setCompany(client);
                  updateCart({ company: client });
                  setCompanyName("");
                  setCompanies(companiesC);
                }}
                onSearch={(text) => {
                  setCompanyName(text);
                  if (text) {
                    let companiesGet = companiesC.filter((item) => {
                      return (
                        item.label.toUpperCase().indexOf(text.toUpperCase()) !=
                        -1
                      );
                    });
                    setCompanies([...companiesGet]);
                  } else {
                    setCompanies(companiesC);
                  }
                }}
                placeholder="procurar por nome"
              />
            </ViewInput>
            <ViewInput>
              <p>Tipo de Solicitação</p>
              <div style={{ display: "flex", gap: 10 }}>
                <Button
                  type={type === "elaboracao" ? "primary" : "default"}
                  style={{
                    flex: 1,
                    height: 33,
                    borderRadius: 6,
                    borderColor: type === "elaboracao" ? "#008037" : "#d9d9d9",
                    backgroundColor: type === "elaboracao" ? "#008037" : "#fff",
                    color:
                      type === "elaboracao" ? "#fff" : "rgba(0, 0, 0, 0.88)",
                    fontWeight: type === "elaboracao" ? "600" : "normal",
                  }}
                  onClick={() => {
                    setType("elaboracao");
                    updateCart({ type: "elaboracao" });
                  }}
                >
                  Elaboração
                </Button>
                <Button
                  type={type === "renovacao" ? "primary" : "default"}
                  style={{
                    flex: 1,
                    height: 33,
                    borderRadius: 6,
                    borderColor: type === "renovacao" ? "#008037" : "#d9d9d9",
                    backgroundColor: type === "renovacao" ? "#008037" : "#fff",
                    color:
                      type === "renovacao" ? "#fff" : "rgba(0, 0, 0, 0.88)",
                    fontWeight: type === "renovacao" ? "600" : "normal",
                  }}
                  onClick={() => {
                    setType("renovacao");
                    updateCart({ type: "renovacao" });
                  }}
                >
                  Renovação
                </Button>
              </div>
            </ViewInput>

            <ViewInput style={{ marginRight: 0 }}>
              <p>Adicione os Serviços</p>
              <Select
                mode="multiple"
                style={{ width: "100%", textAlign: "left" }}
                placeholder="seleciona o serviço"
                value={null}
                showSearch
                optionFilterProp="children"
                disabled={!sector}
                onChange={(value) => {
                  if (servicesOrder.find((item) => item.id == value[0])) {
                    toast.warn("Serviço já adicionado");
                  } else {
                    const serviceToAdd = services.find(
                      (item) => item.id === value[0],
                    );

                    if (serviceToAdd) {
                      const newServicesOrder = [
                        ...servicesOrder,
                        { ...serviceToAdd, amount: 0 },
                      ];

                      setServicesOrder(newServicesOrder);
                      updateCart({ servicesOrder: newServicesOrder });
                      toast.success("Serviço adicionado com sucesso!");
                    }
                  }
                }}
              >
                {services
                  .filter(
                    (data) =>
                      data.sector == sector &&
                      (!data.min_collaborators ||
                        data.min_collaborators <= collaborators) &&
                      (!data.max_collaborators ||
                        data.max_collaborators >= collaborators),
                  )
                  .map((item, index) => {
                    return (
                      <Select.Option value={item.id}>
                        {item.name} - {getValue(item.value || 0)}
                      </Select.Option>
                    );
                  })}
              </Select>
            </ViewInput>

            <ViewInput style={{ width: "100%", marginRight: 0 }}>
              <p>Observação</p>
              <Input.TextArea
                type="text"
                placeholder="deixe aqui uma observação para o técnico."
                value={observation}
                onChange={(text) => {
                  setObservation(text.target.value);
                  updateCart({ observation: text.target.value });
                }}
              />
            </ViewInput>
            <div
              style={{
                display: "flex",
              }}
            >
              <ViewInput
                style={{
                  marginRight: 0,
                  marginBottom: 0,
                  width: 150,
                  textAlign: "start",
                }}
              >
                <p style={{ marginTop: 4 }}>
                  Urgência (+ R$ 147,00)
                  <Tooltip title="Solicitando a urgência da sua OS no custo de R$ 147,00, ela será finalizada em menos de 24hrs">
                    <MdInfoOutline
                      size={16}
                      style={{
                        marginLeft: 10,
                        marginBottom: -4,
                      }}
                    />
                  </Tooltip>
                </p>
                <Switch
                  style={{ marginTop: 5 }}
                  checked={isUrgent}
                  onChange={(checked) => {
                    setIsUrgent(checked);
                    updateCart({ isUrgent: checked });
                  }}
                />
              </ViewInput>
              <ViewInput
                style={{
                  marginRight: 0,
                  marginBottom: 0,
                  width: 150,
                  textAlign: "start",
                  alignSelf: "flex-start",
                }}
              >
                <p style={{ marginTop: 4 }}>
                  Lembrete de renovação
                  <Tooltip title="Ao ativar, será criado um lembrete de renovação da OS em um ano">
                    <MdInfoOutline
                      size={16}
                      style={{
                        marginLeft: 10,
                        marginBottom: -4,
                      }}
                    />
                  </Tooltip>
                </p>
                <Switch
                  style={{ marginTop: 5 }}
                  checked={reminder}
                  onChange={(checked) => {
                    setReminder(checked);
                    updateCart({ reminder: checked });
                  }}
                />
              </ViewInput>
            </div>
            {sector && (
              <>
                <Services>
                  {servicesOrder.map((item, index) => {
                    return (
                      <div>
                        <div>
                          <Button
                            type="primary"
                            onClick={() => {
                              let servicesA = [...servicesOrder];
                              servicesA[index].amount++;
                              setServicesOrder(servicesA);
                              updateCart({ servicesOrder: servicesA });
                            }}
                          >
                            <MdAdd color="#FFF" size={20} />
                          </Button>
                          <span>{item.amount}</span>
                          <Button
                            type="primary"
                            onClick={() => {
                              let servicesA = [...servicesOrder];
                              if (servicesA[index].amount > 0) {
                                servicesA[index].amount--;
                                setServicesOrder(servicesA);
                                updateCart({ servicesOrder: servicesA });
                              }
                            }}
                          >
                            <MdRemove color="#FFF" size={20} />
                          </Button>
                        </div>
                        <p>
                          {item.name}
                          {item.required_company && (
                            <span
                              style={{
                                background: "#faad14",
                                color: "#fff",
                                padding: "2px 8px",
                                borderRadius: "4px",
                                fontSize: "11px",
                                fontWeight: "600",
                                marginLeft: "10px",
                                display: "inline-block",
                                verticalAlign: "middle",
                              }}
                            >
                              Necessário vincular formulário
                            </span>
                          )}
                        </p>
                        <Button
                          type="primary"
                          danger
                          onClick={() => {
                            const newServices = servicesOrder.filter(
                              (data) => data.id != item.id,
                            );
                            setServicesOrder(newServices);
                            updateCart({ servicesOrder: newServices });
                          }}
                          style={{
                            width: 20,
                            padding: 0,
                          }}
                        >
                          <MdDelete />
                        </Button>
                        {item.description && (
                          <Button
                            type="primary"
                            onClick={() => {
                              setDescription(item.description);
                              setName(item.name);
                              setValue(item.value);
                              setVisibleModal(true);
                            }}
                            style={{
                              marginLeft: 10,
                            }}
                          >
                            Detalhes
                          </Button>
                        )}
                        <p
                          style={{
                            minWidth: 80,
                            maxWidth: 80,
                            textAlign: "right",
                          }}
                        >
                          {getValue(item.value || 0)}
                        </p>
                      </div>
                    );
                  })}
                  {isUrgent && (
                    <div>
                      <p>Taxa de Urgencia</p>
                      <p style={{ textAlign: "end" }}>R$ 147,00</p>
                    </div>
                  )}
                </Services>
              </>
            )}

            <div
              className="service"
              style={{ border: "none", padding: "0 25px", marginTop: 25 }}
            >
              <p style={{ flex: 1 }}>Resumo</p>
              <p>Valor</p>
            </div>
            <Resume>
              <div>
                {order?.items?.map((item) => {
                  return (
                    <div className="service">
                      <p style={{ flex: 1 }}>{item.name}</p>
                      <p>
                        {item.amount}x {getValue(item.value)}
                      </p>
                    </div>
                  );
                })}
              </div>
              <div class="checkout-summary">
                <div class="left-section">
                  <ViewInput style={{ marginBottom: 10 }}>
                    <p>Cupom de Desconto</p>
                    <div style={{ display: "flex" }}>
                      <Input
                        placeholder="insira o cupom"
                        value={code}
                        onChange={(text) => {
                          setCode(text.target.value);
                          updateCart({ code: text.target.value });
                        }}
                        allowClear
                      />
                      <Button
                        className="button"
                        type="primary"
                        loading={loadingCode}
                        style={{
                          borderRadius: 2,
                          marginLeft: 10,
                          marginBottom: 0,
                          width: 90,
                          fontSize: 15,
                        }}
                        onClick={() => {
                          getCoupon();
                        }}
                      >
                        Aplicar
                      </Button>
                    </div>
                  </ViewInput>
                  {discount && (
                    <div class="discount-info">
                      Cupom aplicado: {discount.code.toUpperCase()}
                      {" - "}
                      <span style={{ color: "#FF0000", marginLeft: 10 }}>
                        {discount.type == "FIXED"
                          ? `${getValue(discount.value || 0)} OFF`
                          : `${discount.value}%`}
                      </span>
                      <Button
                        type="primary"
                        danger
                        onClick={() => {
                          setDiscount(null);
                          updateCart({ discount: null });
                        }}
                        style={{
                          width: 20,
                          height: 25,
                          padding: 0,
                          marginLeft: 15,
                        }}
                      >
                        <MdDelete size={12} />
                      </Button>
                    </div>
                  )}
                </div>
                <div class="right-section">
                  <div class="line">
                    <span>Total</span>
                    <span class="amount">
                      {getValue(
                        servicesOrder.reduce((total, item) => {
                          const subtotal = item.value * item.amount;
                          return total + subtotal;
                        }, 0) + (isUrgent ? 147 : 0) || 0,
                      )}
                    </span>
                  </div>
                  {discount && (
                    <div class="line">
                      <span>Desconto</span>
                      <span class="amount">
                        {getValue(
                          discount.type == "FIXED"
                            ? discount.value
                            : (servicesOrder.reduce((total, item) => {
                                const subtotal = item.value * item.amount;
                                return total + subtotal;
                              }, 0) + (isUrgent ? 147 : 0) || 0) *
                                (discount.value / 100) || 0,
                        )}
                      </span>
                    </div>
                  )}
                  <div class="line">
                    <span class="badge">
                      {servicesOrder.reduce((total, item) => {
                        return total + item.amount;
                      }, 0) + (isUrgent ? 1 : 0) || 0}{" "}
                      itens
                    </span>
                    <span class="final-label">Valor final</span>
                    <span class="amount">
                      {getValue(
                        (servicesOrder.reduce((total, item) => {
                          const subtotal = item.value * item.amount;
                          return total + subtotal;
                        }, 0) + (isUrgent ? 147 : 0) || 0) -
                          (discount
                            ? discount.type == "FIXED"
                              ? discount.value
                              : (servicesOrder.reduce((total, item) => {
                                  const subtotal = item.value * item.amount;
                                  return total + subtotal;
                                }, 0) + (isUrgent ? 147 : 0) || 0) *
                                  (discount.value / 100) ||
                                0 ||
                                0
                            : 0),
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </Resume>
            <div className="buttonRight">
              <Button
                type="primary"
                loading={isLoadingButton}
                className="next"
                onClick={async () => {
                  if (!collaborators) {
                    toast.warn(
                      `Preencha a quantidade de funcionarios da empresa`,
                    );
                    return "";
                  }
                  if (isFormRequired && !company?.id) {
                    toast.warn("Vincule o formulário da empresa antes de continuar");
                    return "";
                  }
                  if (servicesOrder.length == 0) {
                    toast.warn("Adicione pelo menos um serviço");
                    return "";
                  }
                  const serviceFound = servicesOrder.find(
                    (item) => item.amount == 0,
                  );

                  if (serviceFound) {
                    toast.warn(
                      `Coloque a quantidade que deseja do serviço ${serviceFound.name}`,
                    );
                    return "";
                  }

                  setIsLoadingButton(true);
                  await api
                    .post("/order", {
                      items: servicesOrder,
                      name: nameOS,
                      company_id: company?.id,
                      urgent: isUrgent,
                      observation: observation,
                      code: code,
                      collaborators: collaborators,
                      sector: sector,
                      reminder: reminder,
                      type: type,
                    })
                    .then((response) => {
                      clearCart();
                      navigate(`/cliente/os/${response.data.id}`);
                    })
                    .catch(({ response }) => {
                      if (response?.data?.message) {
                        toast.error(response?.data?.message);
                      } else {
                        toast.error(
                          "Erro Interno. verifique sua conexão e tente novamente",
                        );
                      }
                    });
                  setIsLoadingButton(false);
                }}
              >
                Continuar
              </Button>
            </div>
          </div>
        </>
      )}
      <Modal
        open={visibleModal}
        onCancel={() => {
          setVisibleModal(false);
        }}
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        cancelText="FECHAR"
      >
        <div
          style={{
            margin: "30px 0 20px 0",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h2 style={{ textAlign: "center", color: "#000" }}>{name}</h2>
          <p
            style={{
              textAlign: "center",
              color: "#000",
              margin: "15px 0",
              fontSize: 16,
            }}
          >
            {description}
          </p>
          <h3 style={{ textAlign: "center", color: "#000" }}>
            {value.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </h3>
        </div>
      </Modal>
    </Container>
  );
}
